import {Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, ViewEncapsulation} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {CommonConstants, RoutesConstants, ImagePathConstants} from '@coreconstant';
import {ResponseHandlerService} from 'src/app/core/services/common-service/response-handler.service';
import {isPlatformBrowser} from '@angular/common';

@Component({
    selector: 'app-venue-map',
    imports: [RouterModule],
    templateUrl: './venue-map.component.html',
    styleUrl: './venue-map.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class VenueMapComponent {

    @Input() slug?: string = '';
    @Input() venueDetails: any
    @Output() backToParent = new EventEmitter<void>();

    imagePathConstants = ImagePathConstants
    commonConstants = CommonConstants
    routesConstants = RoutesConstants
    mapUrl: any;

    constructor(
        @Inject(PLATFORM_ID) private platformId: object,
        private _responseHandlerService: ResponseHandlerService,
        private _sanitizer: DomSanitizer
    ) {
    }

    /**
     * Initializes the component and its dependent processes.
     */
    ngOnInit(): void {
        if (this.venueDetails.addressLatitude && this.venueDetails.addressLongitude) {
            let url = this.commonConstants.STAY22_MAP_URL + '?aid=' + this.commonConstants.STAY22_URL_AID_PARAMETER + '&lat=' + this.venueDetails.addressLatitude + 'lng=' + this.venueDetails.addressLongitude
            if (this.venueDetails.venueAddress) {
                url += '&address=' + this.venueDetails.venueAddress
            }
            url += this.commonConstants.STAY22_MAP_CONFIGURATIONS_URL
            this.mapUrl = this._sanitizer.bypassSecurityTrustResourceUrl(url);
        }
        this.scrollToTop()
    }

    /**
     * Copy map URL to clipboard
     */
    copyMapUrl() {
        const input = document.createElement('input');
        input.value = this.commonConstants.GOOGLE_MAP_URL_TO_OPEN + this.venueDetails?.addressLatitude + ',' + this.venueDetails?.addressLongitude
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this._responseHandlerService.showSuccessMessageGeneral(this.commonConstants.LINK_COPY)
    }

    /**
     * Scrolls the window to the top of the page with a smooth scrolling animation.
     */
    scrollToTop() {
        if (isPlatformBrowser(this.platformId)) {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    }

    /**
     * Navigates back to the parent component or previous state by emitting a signal or event.
     */
    goBack() {
        this.backToParent.emit();
    }
}
